const COPIED_LABEL = 'Kopiert';
const RESTORE_MS = 3000;

function copyToClipboard(text) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
}

document.addEventListener(
    'click',
    function (e) {
        const btn = e.target.closest('.topBookmakes_copyBtn, .topBookmakes_copyBtn_sidebar');
        if (!btn) {
            return;
        }

        e.preventDefault();
        e.stopPropagation();

        const textEl = btn.querySelector('.topBookmakes_copyBtn_text');
        if (!textEl) {
            return;
        }

        if (!textEl.dataset.originalCode) {
            textEl.dataset.originalCode = textEl.textContent.trim();
        }

        const code = textEl.dataset.originalCode;
        if (!code) {
            return;
        }

        copyToClipboard(code);
        textEl.textContent = COPIED_LABEL;

        const existingTimer = textEl._topBookmakesCopyRestoreTimer;
        if (existingTimer) {
            clearTimeout(existingTimer);
        }

        textEl._topBookmakesCopyRestoreTimer = setTimeout(function () {
            textEl.textContent = textEl.dataset.originalCode;
            textEl._topBookmakesCopyRestoreTimer = null;
        }, RESTORE_MS);
    },
    true
);
